module.exports = __webpack_public_path__ + "img/modules/assets/img/default-avatar.9e4c98489b37038b007107c7545c47cb.jpg";